import { render, staticRenderFns } from "./platformRules.vue?vue&type=template&id=dd2ab98c&"
import script from "./platformRules.vue?vue&type=script&lang=js&"
export * from "./platformRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports